module.exports = __webpack_public_path__ + "static/media/pm-download.0a69c52b.svg";